import React from 'react';

const Footer = () => (
  <footer className="bg-white border-t border-[#E8E2DA] py-14">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-xl bg-[#1A1A18] flex items-center justify-center text-sm">🦞</div>
          <span className="text-base font-bold text-[#1A1A18]">HelloClaw</span>
        </div>
        <div className="flex gap-8">
          {['Privacy Policy', 'Terms of Service', 'Contact'].map((link) => (
            <a key={link} href="#" className="text-[#9E9690] hover:text-[#1A1A18] transition-colors font-mono-custom text-[11px] uppercase tracking-wider">
              {link}
            </a>
          ))}
        </div>
      </div>
      <div className="mt-10 pt-8 border-t border-[#EDE9E4]">
        <div className="text-center mb-5">
          <p className="text-sm font-semibold text-[#1A1A18] mb-1">Your personal assistant, ready when you are.</p>
          <p className="text-xs text-[#9E9690] max-w-md mx-auto leading-relaxed">
            Claw is the beginning. The same intelligence that runs your personal life can run your business too.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-[#9E9690] font-mono-custom">© 2026 HelloClaw · <a href="https://helloclaw.com" className="hover:text-[#1A1A18] transition-colors">helloclaw.com</a> — a CHRSMA company.</p>
          <p className="text-xs text-[#9E9690] font-mono-custom">Built with care for people who value their time.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;